import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useCreateCompany = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post("/Company/CreateCompany", formData);
  });
  return mutation;
};
export default useCreateCompany;
